/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { updatePriceSizeSchema } from "./updatePriceSizeSchema.ts";

export const updatePriceSizeRequestSchema = updatePriceSizeSchema;
